import { Box, CircularProgress, FormControlLabel, Radio } from "@mui/material";
import React from "react";
import { Button } from "reactstrap";
import "./style.css";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import BlueButton from "../Button/BlueButton";
import { formatUSD } from "../../utils/usFormat";

const Summary = ({ formik, plan, loading, isDonationMode = false, dejavooDisabled = false, onAddSubscriptionClick }) => {
  function getPlanFrequencyDisplay(monthFrequency) {
    if (monthFrequency === "12 (Annually)") {
      return "year";
    } else if (monthFrequency === "1") {
      return `month`;
    } else {
      return `${monthFrequency?.split(" ")[0]} month`;
    }
  }

  function formatDate(date) {
    const options = { month: "2-digit", day: "2-digit", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <Grid className=" h-auto second-card">
      <Box
        className="space p-3 h-100 summary-box border-blue-color"
        sx={{
          border: "1px solid var(--border-blue-color)",
          borderRadius: "8px",
          backgroundColor: "var(--bg-white-color)",
        }}
      >
        <Grid className="d-flex justify-content-between summary-main side summaryPlanNamePayment">
          <Typography
            style={{ fontSize: "23px", fontWeight: 600 }}
            className="paymentInfoLike heading-four text-blue-color"
          >
            Summary{" "}
          </Typography>
          <Typography
            style={{ fontSize: "25px", fontWeight: 600 }}
            className="paymentInfoLikheading-foure text-blue-color"
          >
            {plan?.PlanName || "PlanName not available"}
          </Typography>
        </Grid>
        <hr className="mt-1 summary-divider" />
        <Grid className="">
          <Grid className="bill d-flex align-items-center justify-content-between">
            <Typography
              style={{ fontSize: "16px", fontWeight: 600 }}
              className="paymentInfoLike text-blue-color"
            >
              Bill Date
            </Typography>
            <Typography
              style={{ fontSize: "16px", fontWeight: 600 }}
              className="paymentInfoLike text-blue-color"
            >
              {formatDate(new Date())}
            </Typography>
          </Grid>
        </Grid>
        <hr className="mt-1 summary-divider" />
        <Grid className="bill d-flex align-items-center justify-content-between">
          <Typography
            style={{ fontSize: "20px", fontWeight: 600 }}
            className="paymentInfoLike text-blue-color"
          >
            Monthly Bill
          </Typography>
          <Typography
            style={{ fontSize: "20px", fontWeight: 600 }}
            className="paymentInfoLike mb-2 text-blue-color"
          >
            {formatUSD(plan?.PlanPrice)}/
            {getPlanFrequencyDisplay(plan?.MonthFrequency)}
          </Typography>
        </Grid>
        <Grid className="bill d-flex align-items-center justify-content-end">
          <Typography
            style={{ fontSize: "15px" }}
            className="paymentInfoLike text-blue-color summary-muted"
          >
            All prices are in $USD
          </Typography>
        </Grid>
        <hr className="summary-divider" />
        <Grid className="d-flex justify-content-start note">
          <Typography className="text-blue-color summary-muted" style={{ fontSize: "10px" }}>
            Payments are non-refundable and will automatically renew unless
            canceled prior to the end of the current billing cycle via your
            Account and Billing page.
          </Typography>
        </Grid>
        <Grid className="d-flex justify-content-center mt-md-4">
          <BlueButton
            isDonationMode={isDonationMode}
            label={
              loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add Subscription"
              )
            }
            onClick={onAddSubscriptionClick || formik?.handleSubmit}
            disabled={loading || dejavooDisabled}
            style={{ 
              fontSize: "18px", 
              color: "white", 
              marginBottom: "10px" 
            }}
          />
        </Grid>
      </Box>
    </Grid>
  );
};

export default Summary;